import React from 'react';

import {
  getCorrectRenewedIcon,
  getCorrectRenewedStatus,
} from 'utils/assignmentUtils';
import BaseLabel from 'components/wrappers/BaseLabel';
import {
  RenewAssignmentEnum,
  RenewKindEnum,
  RenewStatusEnum,
} from 'api/backofficeApiClient';

type Props = {
  renewStatus?: RenewStatusEnum;
  renewKind?: RenewKindEnum;
  renewType?: RenewAssignmentEnum;
};
export default function RenewStatusLabel(props: Props) {
  const { renewStatus, renewKind, renewType } = props;

  const isAssignmentRenewed =
    renewStatus === RenewStatusEnum.Renewed &&
    renewKind === RenewKindEnum.Renew;

  const isAssignmentRehired =
    renewStatus === RenewStatusEnum.Renewed &&
    renewKind === RenewKindEnum.Rehire &&
    (renewType === RenewAssignmentEnum.WithChanges ||
      renewType === RenewAssignmentEnum.WithoutChanges);

  const isAssignmentRehiredWithChangeCustomer =
    renewStatus === RenewStatusEnum.Renewed &&
    renewType === RenewAssignmentEnum.WithChangeCustomer &&
    renewKind === RenewKindEnum.Rehire;

  const hasRenewStatus =
    isAssignmentRenewed ||
    isAssignmentRehired ||
    isAssignmentRehiredWithChangeCustomer;

  if (!hasRenewStatus) return null;

  return (
    <BaseLabel
      iconClasses={getCorrectRenewedIcon(
        isAssignmentRehired,
        isAssignmentRehiredWithChangeCustomer,
      )}
      status={getCorrectRenewedStatus(
        isAssignmentRehired,
        isAssignmentRehiredWithChangeCustomer,
      )}
    />
  );
}
